import { render } from "./SidebarCaseStatus.vue?vue&type=template&id=1819c07b"
import script from "./SidebarCaseStatus.vue?vue&type=script&lang=js"
export * from "./SidebarCaseStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__